import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { clearSubmitMark, shouldForceCloseOnRender } from "../lib/modal_submit_mark"

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element)
    this.modal.show()
  }

  hideBeforeRender(event) {
    if (!this.isOpen()) { return }

    // Same rule as base_modal.js#_hideBeforeRender (both controllers sit on
    // this element): a morph only closes the modal whose own form just
    // submitted — the element-level mark is written by BaseModal's submit
    // listener. Unmarked open modals are data-turbo-permanent and survive
    // the morph. Full-page renders still close everything.
    if (!shouldForceCloseOnRender(this.element, event)) { return }

    clearSubmitMark(this.element)
    event.preventDefault()
    this.element.addEventListener('hidden.bs.modal', event.detail.resume)
    // Render-forced close, not a user dismissal — skip BaseModal's
    // dirty-form confirm (see base_modal.js#_hideBeforeRender).
    this.element._skipDirtyConfirm = true
    this.modal.hide()
    this.element._skipDirtyConfirm = false
  }

  isOpen() {
    return this.element.classList.contains("show")
  }
}
